import React, {Component} from 'react';
import axios from 'axios';
import './Complaintitem.css';
class Complaintitem extends React.Component {
  constructor(props){
    super(props);

}
  render() {
    return <div>

<div className="container">
  <div className="text-left justify-content-center ">

    <div>
      <h3 className="pb-4 pt-4">Lorem Epsum Mycomplaint pre<br/>defined text(complaint text)</h3>
      <h3 className="inline select-items">Select Items </h3> <div className="custom-control custom-checkbox float-right">
                		<input type="checkbox" className="custom-control-input " id="defaultUnchecked"/>
                	 	<label className="custom-control-label  select-all " for="defaultUnchecked"></label>
                  <span className="slect-all">Select All</span>
              		</div>
    </div>

       

                      
      
      
<div >
                    <ul class="category  ">
                    <li><div class="custom-control custom-checkbox " ><input type="checkbox" class="custom-control-input" id="defaultUnchecked-1"/><label class="custom-control-label product-details " for="defaultUnchecked-1"><img src="assets/images/product-img/product-img-1.jpg" className="product-thumbnails" alt=""/>Product title 500gm x1</label>
                    <span class="float-right rate">₹15</span>  </div></li><hr className="com-line"/>

                    <li><div class="custom-control custom-checkbox"><input type="checkbox" class="custom-control-input" id="defaultUnchecked-2"/><label class="custom-control-label product-details" for="defaultUnchecked-2"> <img src="assets/images/product-img/product-img-1.jpg" className="product-thumbnails" alt=""/>Product title 500gm x1</label>
                    <span class="float-right rate">₹15</span> </div></li><hr className="com-line"/>
                          
                      <li><div class="custom-control custom-checkbox"> <input type="checkbox" class="custom-control-input" id="defaultUnchecked-3"/><label class="custom-control-label product-details" for="defaultUnchecked-3"> <img src="assets/images/product-img/product-img-1.jpg" className="product-thumbnails" alt=""/>Product title 500gm x1</label>
         <span class="float-right rate">₹15</span></div></li> 
         </ul> 
 </div>



    <div className="inline mt-2 ml-3 mb-5 mobil-btn2 com-itm-btn ">
        <button type="button" class="  btnn btn-hover btn-outline-success tag-btn  ">Cancel</button>

        <button type="button" class=" add-to-cart2 btnn tag-btn mb-2  ">Next</button>
      </div>
</div>


</div>







    </div>
    }
}

export default Complaintitem;
